<template>
  <div>
    <my-notification :icon="'joomla'">
      <template #title>
        <div v-html="$t('compTransitionDocsTeam.coordTeam')"></div>
      </template>
      <ul class="bcteam">
        <li>Marie-Alice Foujols: <em>IPSL, Paris</em></li>
        <li>Céline Serrano : <em>INRIA, Paris</em></li>
        <li>Matthieu Simonin : <em>INRIA, Rennes</em></li>
      </ul>
    </my-notification>

    <my-notification :icon="'keyboard-o'">
      <template #title>
        <div v-html="$t('compTransitionDocsTeam.devTeam')"></div>
      </template>
      <ul class="bcteam">
        <li>Philippe Bardou : <em>INRIAE, Toulouse</em></li>
        <li>Mickael Coriat : <em>Université Paul Sabatier, Toulouse</em></li>
        <li>Fabrice Jammes : <em>CNRS, Clermont-Ferrand</em></li>
        <li>Gérald Salin : <em>INRAE, Toulouse</em></li>
        <li>Jérôme Mariette : <em>INRAE, Toulouse</em></li>
        <li>Matthieu Simonin : <em>INRIA, Rennes</em></li>
      </ul>
    </my-notification>

    <my-notification :icon="'users'">
      <template #title>
        <div v-html="$t('compTransitionDocsTeam.celluleTeam')"></div>
      </template>
      <p>
        En décembre 2023, la cellule d’animation est composée de personnels des
        organismes de recherche et des établissements d’enseignement supérieur
        et recherche qui se sont portés volontaires :
      </p>
      <ul class="bcteam">
        <li>Muriel Andrieu,</li>
        <li>Marie-Alice Foujols,</li>
        <li>Françoise Immel,</li>
        <li>Emilie Jardé,</li>
        <li>Matthieu Mandard,</li>
        <li>Nunzia Savoia,</li>
        <li>Sophie Schbath,</li>
        <li>Céline Serrano,</li>
        <li>Matthieu Simonin,</li>
      </ul>
    </my-notification>

    <my-notification :icon="'pencil'">
      <template #title>
        <div v-html="$t('compTransitionDocsTeam.reviewTeam')"></div>
      </template>
      En mai 2023, l'équipe de relecture est constituée des membres de la
      cellule d'animation.
    </my-notification>
  </div>
</template>

<script>
export default {
  name: 'Team',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue')
  }
}
</script>

<style lang="css" scoped>
.bcteam {
  list-style-type: square;
  margin-left: 25px;
}
.bcteam > li {
  padding-top: 5px;
}
</style>
